module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.a3ce4440.ttf";